export default defineNuxtRouteMiddleware(async (to) => {
    const supabase = useSupabaseClient()
    const { data: session } = await supabase.auth.getUser()

    if (!session || !session.user) return navigateTo('/loginx')

    const { data: profile, error } = await supabase
        .from('profiles')
        .select('role')
        .eq('id', session.user.id)
        .single()

    if (error || !profile) return navigateTo('/loginx')

    // If a route requires admin, check the user role
    if (to.meta.requiresAdmin && profile.role !== 'admin') {
        return navigateTo('/unauthorized')
    }
})
